<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('connection profiles')"
      :columns="columns"
      :column_search="true"
      resource_url="/onfido/profile/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <profile-modal ref="profile_modal" @success="refresh" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import ProfileModal from "../profile_modal/Index.vue";

export default {
  name: "ProfilesDatatable",
  components: { GenericTable, ProfileModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("profile"),
          searchable: false,
          width: "80%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="columns">
                      <div class="column is-9">
                        <div class="title is-5 mb-0">${row.name}</div>                        
                      </div>
                    </div>`;
          },
        },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.profile_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete profile?"),
                    v,
                    () => {
                      del("/onfido/profile", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.profile_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
